module.exports = __webpack_public_path__ + "static/media/05_good_01_ko.b173df9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/intro-3/05_good_01_ko.png
// module id = 715
// module chunks = 0